export const imagePlaceholders = {
  project: 'assets/img/svgs/code-solid.svg',
  foundation: 'assets/img/svgs/codepen-brands.svg',
  logo: 'assets/img/svgs/image-solid.svg',
  company: 'assets/img/svgs/building-solid.svg',
  user: 'assets/img/svgs/user-solid.svg',
};
